import fieldsStore from '../../components/apia/execution/fieldsStore/fieldsStore';
import ApiaField from '../ApiaField';
import ApiaForm from '../ApiaForm';
import Field from '../constants/Field';
import { IApiaField } from '../types';

export interface IButtonField extends IApiaField {
  fireClickEvent(): IButtonField | null;
  getValue(): unknown;
  getLabel(): void;
  clearValue(): null | void;
}

export default class ButtonField extends ApiaField implements IButtonField {
  constructor(field: HTMLButtonElement, form: ApiaForm) {
    super(field, form, [
      Field.PROPERTY_READONLY,
      Field.PROPERTY_VISIBILITY_HIDDEN,
    ]);
  }

  fireClickEvent(): IButtonField | null {
    if (this.checkFieldExistsInDocument(this.fldId)) {
      this.field.click();
      return this as IButtonField;
    }
    return null;
  }

  getValue(): unknown {
    if (this.checkFieldExistsInDocument(this.fldId) && this.fldId !== null) {
      return fieldsStore.getById(this.fldId).getValue();
    }
    return null;
  }

  getLabel(): void {
    throw new Error(
      `Apia JSApi Error: The field ${
        this.fldType as string
      } does not use a label`,
    );
  }

  clearValue(): null | void {
    return null;
  }
}
